<template>
    <div @click="visible=true">
        <a-select size="small" mode="tags" :token-separators="[',']" :open="false" v-model="checkedList" @change="onChange" style="width: 100%;">
            <a-select-option v-for="item in staffs" :key="item.id">
                {{ item.name }}
            </a-select-option>
        </a-select>
        <a-modal v-model="visible" @ok="handleOk" :footer="null" :width="600">
            <div class="flex" style="height: 400px;">
                <div class="flex-width flex-column">
                    <a-input-search placeholder="搜索员工" v-model="search" size="small" />
                    <div class="flex-height">
                        <a-tabs default-active-key="1" size="small" class="h100">
                            <a-tab-pane key="1" tab="按字母">
                                <div style="height: 300px;" class="scroll">
                                    <a-checkbox-group @change="onChange" size="small" class="w100" v-model="checkedList">
                                        <div v-for="item in staffList" :key="item.id" class="flex items-center w100">
                                            <a-checkbox :value="item.id" size="small">
                                                <span class="fs12">{{ item.name || item.username }}</span>
                                            </a-checkbox>
                                            <div class="fs12 flex-width flex-reverse">
                                                <div class="pr10 pl10" style="background-color: #f2f2f2; color: #9c9c9c;">
                                                    {{ item.dep_name }}
                                                </div>
                                            </div>
                                        </div>
                                    </a-checkbox-group>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="2" tab="按部门">
                                <div style="height: 300px;" class="scroll">
                                    <a-tree
                                        size="small"
                                        v-model="checkedList"
                                        checkable
                                        :expanded-keys="expandedKeys"
                                        :auto-expand-parent="autoExpandParent"
                                        :selected-keys="selectedKeys"
                                        :tree-data="depData"
                                        @expand="onExpand"
                                        @select="onSelect"
                                        @check="onCheck"
                                    />
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
                <div class="ml10 mr10" style="background-color: #e8e8e8; width: 1px; height: 100%;"></div>
                <div style="width: 200px;" class="h100 flex-column">
                    <div>
                        已选中 {{ selectedPerson.length }} 人
                    </div>
                    <div class="flex-height scroll mt10">
                        <div v-for="item in selectedPerson" :key="item.id" class="mb5">
                            <a-tag closable>{{item.name || item.username}}</a-tag>
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props:{
        // visible:{
        //     type:Boolean,
        //     default:false
        // }
    },
    data() {
        return {
            visible: false,
            staffs: [],
            treeData: [],
            checkedList: [],
            expandedKeys: ['0'],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            selectedPerson: [],
            search: "",
            visibleAdd:true,
        }
    },
    props: ["value"],
    watch: {
        value(n, o) {
            // console.log(n)
            if (n.length == 0) {
                this.checkedList = [];
            }
            this.checkedList = n;
        }
    },
    computed: {
        staffList() {
            if (this.search == "") {
                return this.staffs;
            } else {
                return this.staffs.filter((it) => {
                    if (it.name != null) {
                        return (it.name.indexOf(this.search) != -1) || (this.checkedList.indexOf(it.id) != -1)
                    } else {
                        return (it.username.indexOf(this.search) != -1) || (this.checkedList.indexOf(it.id) != -1)
                    }
                });
            }
        },
        depData() {
            if (this.search == "") {
                return this.treeData;
            } else {
                let children = [];
                let deps = {};
                for (let item of this.staffs) {
                    if (item.name != null) {
                        if ((item.name.indexOf(this.search) == -1) && (this.checkedList.indexOf(item.id) == -1)) {
                            continue;
                        }
                    }
                    
                    item.id = item.id.toString();
                    let dep_id = item.dep_id || 0;
                    if (dep_id == 0) {
                        children.push({
                            title: item.name,
                            key: item.id
                        })
                    } else {
                        if (deps[dep_id] == null) {
                            deps[dep_id] = {
                                title: item.dep_name,
                                // key: `d-${item.dep_id}`,
                                key: item.dep_id,
                                children: []
                            }
                            children.push(deps[dep_id])
                        }
                        if (deps[dep_id].children == null) {
                            deps[dep_id].children = [];
                        }
                        deps[dep_id].children.push({
                            title: item.name,
                            key: item.id
                        })
                    }
                }
                // for(let item of this.checkedList){
                //     let part = this.staffs.find(it=>it.id == item)
                //     if(part != null){
                //         children.push({id:part.id, title:part.name})
                //     }
                // }
                // console.log(this.checkedList)
                
                let treeData = [{
                    title: "浙江大虞建设有限公司",
                    key: "0",
                    children
                }]
                // console.log(treeData)
                return treeData;
            }
        },
    },
    created() {
        this.getCompanyStaff();
    },
    methods: {
        async getCompanyStaff() {
            let rs = await this.$api.getCompanyStaff();
            if (rs.err == 0) {
                let personMap = {};
                for (let item of rs.data) {
                    personMap[item.id] = item;
                }
                let data = [];
                for (let key in personMap) {
                    data.push(personMap[key])
                }
                data.sort((a,b)=>{
                    return a.name - b.name;
                })
                this.staffs = data;
                let ca = 1
                for(let part of this.staffs){
                    if(part.name == null){
                        part.name =  part.username
                    }
                    part.key = ca
                    ca++
                }
                // console.log(this.staffs)
                let children = [];
                let deps = {};
                // deps[0] = children;
                for (let item of rs.data) {
                    item.id = item.id.toString();
                    let dep_id = item.dep_id || 0;
                    if (dep_id == 0) {
                        children.push({
                            title: item.name,
                            key: item.id
                        })
                    } else {
                        if (deps[dep_id] == null) {
                            deps[dep_id] = {
                                title: item.dep_name,
                                key: `d-${item.dep_id}`,
                                // key: item.dep_id,
                                children: []
                            }
                            children.push(deps[dep_id])
                        }
                        if (deps[dep_id].children == null) {
                            deps[dep_id].children = [];
                        }
                        deps[dep_id].children.push({
                            title: item.name,
                            key: item.id
                        })
                    }
                    
                }
                
                this.treeData = [{
                    title: "浙江大虞建设有限公司",
                    key: "0",
                    children
                }]
            }
        },
        handleOk() {

        },
        onChange() {
            for (let i = this.checkedList.length - 1; i >= 0; i--) {
                if (this.checkedList[i].indexOf("d-") != -1) {
                    this.checkedList.splice(i, 1)
                }
            }
            this.selectedPerson = this.staffs.filter((it) => {
                return this.checkedList.indexOf(it.id) != -1
            })
            this.$emit("input", this.checkedList);
            this.$emit("change", this.checkedList);

        },

        onExpand(expandedKeys) {
            // console.log('onExpand', expandedKeys);
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        onCheck(checkedKeys) {
            // console.log('onCheck', checkedKeys);
            this.checkedList = checkedKeys.filter(item => (!Number.isInteger(item))&&item != '0');;
            // this.checkedList = checkedKeys;
            this.onChange();
        },
        onSelect(selectedKeys, info) {
            // console.log('onSelect', info);
            this.selectedKeys = selectedKeys;
        },
        clearSelect(){
            this.selectedPerson = []
        },
    }
}
</script>

<style>
.ant-tree-title {
    font-size: 12px;
}
</style>